import WebPortalProvider from './webportal'

// Give arg to provider to start endpoint with specific path for example = xxx.com/api/person
export const WebPortalService = new WebPortalProvider('portal')